import React from 'react';
import {
  Facebook as FacebookIcon,
  Google as GoogleIcon,
  Instagram as InstagramIcon,
  Telegram as TelegramIcon,
  X as XIcon,
} from '@mui/icons-material';

// Platform Constants - Global brand and contact information

export const PLATFORM_NAME = 'Porvenix';

export const PLATFORM_CONTACT = {
  SUPPORT_EMAIL: 'ernesto@porvenix.com',
  MAILTO_SUPPORT: 'mailto:ernesto@porvenix.com',
  SUPPORT_PHONE: '+1 (555) 123-4567',
  TELEGRAM_CONTACT_US: 'https://t.me/scporvenix',
  SUPPORT_PHONE_RAW: '+15551234567',
  GOOGLE_MAPS_LINK: 'https://maps.google.com',
};

export const PLATFORM_SOCIAL_LINKS = [
  {
    name: 'Instagram',
    icon: React.createElement(InstagramIcon),
    href: 'https://www.instagram.com/porvenix',
    color: '#E4405F',
  },
  {
    name: 'Facebook',
    icon: React.createElement(FacebookIcon),
    href: '',
    color: '#1877F2',
  },
  {
    name: 'X',
    icon: React.createElement(XIcon),
    href: 'https://x.com/porvenix',
    color: '#000000',
  },
  {
    name: 'Google',
    icon: React.createElement(GoogleIcon),
    href: '',
    color: '#DB4437',
  },
  {
    name: 'Telegram',
    icon: React.createElement(TelegramIcon),
    href: 'https://t.me/+USNq9ha7E5wzNTUx',
    color: '#0088cc',
  },
  {
    name: 'Telegram Contact Us',
    icon: React.createElement(TelegramIcon),
    href: PLATFORM_CONTACT.TELEGRAM_CONTACT_US,
    color: '#0088cc',
  },
];
